export default "__VITE_ASSET__6LPn6_Ow__"